// extracted by mini-css-extract-plugin
export default {"navbar":"styles-module__navbar___YH7Kt"};